export const HOTO_SITE = "HOTO_SITE";
export const GO_LIVE_FILTER = "GO_LIVE_FILTER"
export const HOTO_ENG_SITE = "HOTO_ENG_SITE";
export const HOTO_MATERIAL_LIST = "HOTO_MATERIAL_LIST";
export const HOTO_DETAILS = "HOTO_DETAILS";
export const HOTO_ALL_DETAILS = "HOTO_ALL_DETAILS";